import React from 'react';
import { Backdrop, Box, Breadcrumbs, Button, Checkbox, CircularProgress, Container, FormControl, FormControlLabel, FormHelperText, FormLabel, Input, InputLabel, MenuItem, Radio, RadioGroup, Select, Stack, TextField, TextareaAutosize, Typography } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

import { useNavigate, useParams } from "react-router-dom";
import Service from '../../util/Service';
import Upload from '../upload/Upload';
import UploadUnico from '../upload/UploadUnico';
import { useLoading } from '../../util/LoadingContext';

import ConfirmDialog from '../common/ConfirmDialog';
import { useProfile } from '../common/useProfile';
import HtmlContent from '../util/HtmlContent';

let qtdAnexo = 0;
export default function DinamicForm(props) {
    const { bg } = props;
    const params = useParams();
    const [task, setTask] = React.useState();
    const [userTask, setUserTask] = React.useState();
    const [orgUser, setOrgUser] = React.useState();
    const [selectedOptions, setSelectedOptions] = React.useState(null);
    const [uploadError, setUploadError] = React.useState(false);
    const [inputValues, setInputValues] = React.useState({});
    const [fieldErrors, setFieldErrors] = React.useState();
    const [files, setFiles] = React.useState([]);
    const [arquivo, setArquivo] = React.useState();
    const [processo, setProcesso] = React.useState();
    
    const prof = useProfile();

    const [modalOpen, setModalOpen] = React.useState(false)
    const [incrementavelFields, setIncrementavelFields] = React.useState([]); // Estado para campos incrementáveis

    const navigate = useNavigate();

    // const { setIsLoading } = useLoading();

    React.useEffect(() => {
        // setIsLoading(true);
        const id = bg ? bg.idProcesso : params.id;        
            Service.GET("/api/bpmn/buscaProcessoPorId/" + id).then(r => {
                // setIsLoading(false);
                console.log( r );
                if( !r){
                    buscaPorNome(id);
                    return;
                }
                setProcesso(r);
                
                const t = r.lstTask.find((i) => i.taskType === "bpmn:UserTask");
                if (t) setTask(t);
                
                if( r.rule ){

                    if( prof.temAcesso( r.rule)){
                        console.log("tem acesso");
                    }else{
                        console.log("n tem acesso");
                    }
                }
                if( prof.isOk ){
                    buscaEstruturaUser();
                }
            });
        
    }, [params.id])

    React.useEffect(() => {
        if (orgUser) {
            setTimeout(() => {
                montaCamposForm()
            }, 2000);
        }
    }, [orgUser]);
    function  buscaPorNome(nome){
        Service.GET("/api/bpmn/buscaProcessoPorNome/" + nome).then(r => {
            // setIsLoading(false);
            console.log( r );            
            setProcesso(r);            
            const t = r.lstTask.find((i) => i.taskType === "bpmn:UserTask");
            if (t) setTask(t);
            if( r.rule ){
                if( prof.temAcesso( r.rule)){
                    console.log("tem acesso");
                }else{
                    console.log("n tem acesso");
                }
            }
            if( prof.isOk ){
                buscaEstruturaUser();
            }
        });

    }
    function montaCamposForm() {        
        if (userTask) {
            let opt = {};
            for (let x in userTask.form) {
                const item = userTask.form[x];
                const el = document.getElementById(x);
                if (el && !el.value) {
                    el.value = item;
                } else {
                    if (typeof item === "number") {
                        opt[x] = dayjs(item);
                    } else {
                        opt[x] = item;
                    }
                }
            }
            setSelectedOptions(opt);
        }
    }

    React.useEffect(() => {
        if (bg) {
            const userTask = bg.lstTaskH.find((i) => i.taskType === "bpmn:UserTask");
            if (userTask) {
                setUserTask(userTask);
            }
        }
    }, [bg])

    function buscaEstruturaUser() {
        Service.GET("/api/security/organograma/user").then(r => {
            setOrgUser(r);
        });
    }

    function getFormData() {
        if( task.html){
            if( !window.blobalSubmit ){
                alert('Função não implementada para obter os dados do formulário. Consulte documentação.');
                return;
            }
            return window.blobalSubmit();
        }
        let dado = {};        
        for (let x in task.form) {
            const form = task.form[x];
            const id = getPropertiesField(form, "id");
            const incrementavel = getPropertiesField(form, "incrementavel");

            if (!id) continue;

            if (form.type === 'checkBox') {
                const selectedValue = selectedOptions[id] || false;                
                const val = selectedValue;
                dado[id] = val;
            } else if (form.type === 'textFieldMoeda') {
                const element = document.getElementById(id);
                const val = element ? parseFloat(element.value.replace(/\./g, '').replace(',', '.')) : "";
                dado[id] = val;
            } else if (form.type === "radio") {
                const selectedValue = selectedOptions[id] || "";
                dado[id] = selectedValue;
                if (selectedValue === 2) {
                    const inputVal = inputValues[id] || "";
                    dado[`${id}_input`] = inputVal;
                }
            } else if (form.type === "dataField") {
                let d = selectedOptions[id];
                const selectedValue = selectedOptions[id] ? "dataField;" + selectedOptions[id].toDate().getTime() : "";
                dado[id] = selectedValue;

            } else if (form.type === "radioGroup") {
                const selectedValue = selectedOptions[id] || ""
                dado[id] = selectedValue;
                if (selectedValue === 2) {
                    const inputVal = inputValues[id] || "";
                    dado[`${id}_input`] = inputVal;
                }
            } else if (form.type === "camposUserLogado") {
            } else if (form.type === "uploadUnico") {
            } else if (form.type === "upload") {
            } else if (form.type === "textArea") {
                const element = document.getElementById(id);
                const val = element ? element.value.trim() : "";
                dado[id] = val;
            } else if (incrementavel === true) {
                const campoPrincipal = document.getElementById(id);
                const valorCampoPrincipal = campoPrincipal ? campoPrincipal.value.trim() : "";
                const inputs = document.querySelectorAll(`[data-group="${id}"] input`);
                const valoresIncrementaveis = Array.from(inputs).map(input => input.value.trim());
                dado[id] = [valorCampoPrincipal, ...valoresIncrementaveis];
            } else if( form.type === 'selectField' ){                
                const element = document.getElementById(id);
                const val = (element && element.innerText) ? element.innerText.trim() : "";
                dado[id] = val;
            } else {
                const element = document.getElementById(id);
                const val = element ? element.value.trim() : "";
                dado[id] = val;
            }
        }
        delete dado.GOVBR;
        delete dado.anexo;
        return dado;
    }
    function valido() {
        let isOk = true;
        const erros = [];        
        for (let i in task.form) {
            const f = task.form[i];            
            const req = getPropertiesField(f, "required");
            if (req === true) {
                if (f.type === 'checkBox') {
                    //sempre true
                }else if (f.type === 'uploadUnico') {
                    if (!arquivo) {
                        isOk = false;
                        erros.push({
                            id: getPropertiesField(f, "id"),
                            errorMessage: getPropertiesField(f, "errorMessage")
                        });
                    } else {
                        const item = arquivo.find(a => a.id === getPropertiesField(f, "id"));
                        if (!item) {
                            isOk = false;
                            erros.push({
                                id: getPropertiesField(f, "id"),
                                errorMessage: getPropertiesField(f, "errorMessage")
                            });
                        }
                    }
                } else if (f.type === 'textField') {
                    const id = getPropertiesField(f, "id");
                    const element = document.getElementById(id);
                    const val = element ? element.value.trim() : "";
                    if (val === "") {
                        isOk = false;
                        erros.push({
                            id: id,
                            errorMessage: getPropertiesField(f, "errorMessage")
                        });
                    }
                }else if( f.type === 'selectField' ){                    
                    const id = getPropertiesField(f, "id");
                    const element = document.getElementById(id);
                    const val = (element && element.innerText) ? element.innerText.trim() : "";
                    if (val === ""  || val.trim().length <=1) {
                        isOk = false;
                        erros.push({
                            id: id,
                            errorMessage: getPropertiesField(f, "errorMessage")
                        });
                    }

                } else {
                    const id = getPropertiesField(f, "id");
                    const element = document.getElementById(id);
                    const val = (element && element.value) ? element.value.trim() : "";
                    if (val === "") {
                        isOk = false;
                        erros.push({
                            id: id,
                            errorMessage: getPropertiesField(f, "errorMessage")
                        });
                    }
                }
            }
        }
        if (!isOk) {
            setFieldErrors(erros);
        }
        return isOk;
    }
    // const childRef = React.useRef(null); // Create a ref for the child component

    function handleSalvar() {
        setUploadError(false);
        let send = {
            idProcesso: params.id,
            idTask: task.idTask,
            userData: {
                organograma: orgUser,
            },
            form: getFormData(),
        };
        //setIsLoading(true);
        if (bg) {
            send.id = bg.idTaskRoot;
            send.idProcesso = bg.idProcesso;
        }
        // console.log("======>", send );
        
        Service.POST("/api/security/userTask/salva", send)
            .then(resp => {
                qtdAnexo = files.length;
                enviaUnico(resp, 0);
                enviaAnexos(resp);
                window.scrollTo(0, 0);
                setModalOpen(false);
                // setIsLoading(false);
                navigate("/", {
                    state: {
                        message: "Tarefa executada!",
                        type: "success"
                    }
                });
            })
            .catch(error => {
                // setIsLoading(false);
                console.error(error);
            });
    }

    function handlerEnviar() {
        if (task && task.cdn) {
            const iframe = document.getElementById('iframe');
            const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
            const j = iframeDocument.getElementById('justificativa').value;

            const form = iframeDocument.forms[0];

            var formData = new FormData(form);

            for (let i = 0; i < form.elements.length; i++) {
                const key = form.elements[i].name;
                const val = form.elements[i].value;
            }
        }else if (task && task.html) {
            setModalOpen(true);
        } else {
            if (!valido()) {
                window.scrollTo(0, 0);
                return;
            }
            setModalOpen(true);
        }
    }

    function handlerVoltar() {
        navigate('/')
    }
    function enviaUnico(form, index) {
        if (!arquivo) {
            return;
        }
        if (arquivo.length <= index) {
            return;
        }

        let a = arquivo[index];

        let dados = new FormData();
        dados.append('file', a.arquivo[0]);
        dados.append('id', a.id);

        Service.UPLOAD("/api/bpmn/anexar/" + form.id + "/" + a.id, dados).then((result) => {
            qtdAnexo--;
            enviaUnico(form, ++index);
        }).catch((e) => {
            console.error(e);
        });
        return;
    }
    function enviaAnexos(form) {
        if (qtdAnexo <= 0) return;

        let file = files[qtdAnexo - 1];
        let dados = new FormData();
        dados.append('file', file);
        Service.UPLOAD("/api/bpmn/anexar/" + form.id, dados).then((result) => {
            qtdAnexo--;
            enviaAnexos(form);
        }).catch((e) => {
            console.error(e);
        });
        return;
    }

    const handleAddField = () => {
        setIncrementavelFields([...incrementavelFields, { id: incrementavelFields.length + 1, value: '' }]);
    };

    const handleRemoveField = (id) => {
        setIncrementavelFields(incrementavelFields.filter(field => field.id !== id));
    };

    const handleIncrementavelChange = (id, value) => {
        const updatedFields = incrementavelFields.map(field =>
            field.id === id ? { ...field, value } : field
        );
        setIncrementavelFields(updatedFields);
    };

    function GetDynamicField(field) {
        const isRequired = getPropertiesField(field, "required");
        // const errorMessage = getPropertiesField(field, "errorMessage");
        const fieldId = getPropertiesField(field, "id");
        const nomeLabel = getPropertiesField(field, "label");
        const isIncrementavel = getPropertiesField(field, "incrementavel");

        const handleBlur = (fieldId, value) => {
            // if (isRequired && value.trim() === '') {
            //     const errorExists = fieldErrors && fieldErrors.some(error => error.id === fieldId);

            //     if (!errorExists) {
            //         const newError = { id: fieldId, errorMessage: errorMessage };
            //         setFieldErrors(prevErrors => prevErrors ? [...prevErrors, newError] : [newError]);
            //     }
            // } else {
            //     setFieldErrors(prevErrors =>
            //         prevErrors ? prevErrors.filter(error => error.id !== fieldId) : []
            //     );
            // }
        };

        if (field.type === 'breadcrumbs') {
            return (
                <div style={{ marginBottom: 20, marginLeft: '-15px' }}>
                    <Breadcrumbs
                        crumbs={[
                            {
                                isHome: true,
                                label: "Home",
                                href: "/"
                            },
                            {
                                active: true,
                                label: nomeLabel
                            }
                        ]}
                    />
                </div>
            );
        }

        if (field.type === 'textField') {
            const nomePlaceHolder = getPropertiesField(field, "placeholder");
            const mascara = getPropertiesField(field, "mascara");
            const isRequired = getPropertiesField(field, "required");
            const er = fieldErrors && fieldErrors.find(error => error.id === fieldId);
            const errorMessage = er ? er.errorMessage : getPropertiesField(field, "errorMessage");
            const showError = fieldErrors && fieldErrors.some(error => error.id === fieldId);

            const handleBlur = (e) => {
                const value = e.target.value.trim();
                //não esta funcionando
                // if (isRequired && value === '') {
                //     const newErrors = fieldErrors ? [...fieldErrors] : [];
                //     if (!newErrors.some(error => error.id === fieldId)) {
                //         newErrors.push({ id: fieldId, errorMessage });
                //         setFieldErrors(newErrors);
                //     }
                // } else {
                //     setFieldErrors((prevErrors) =>
                //         prevErrors ? prevErrors.filter(error => error.id !== fieldId) : []
                //     );
                // }
                // if (mascara === 'email' && e.target.value) {
                //     const ret = validateEmail(e.target.value)
                //     if (!ret) {
                //         const newErrors = fieldErrors ? [...fieldErrors] : [];
                //         if (!newErrors.some(error => error.id === fieldId)) {
                //             newErrors.push({ id: fieldId, errorMessage: "Email inválido." });
                //             setFieldErrors(newErrors);
                //         }
                //     }
                // }
            };
            function validateEmail(email) {
                const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                return re.test(email);
            }
            function formataCEP(e) {
                let val = e.target.value;
                if (val.length >= 9 && e.key.length === 1 && e.key !== 'a') {
                    val = val.substring(0, 9)
                    e.preventDefault();
                } else {
                    val = val.replace(/\D/g, "")
                    val = val.replace(/(\d{5})(\d)/, "$1-$2")
                    // val=val.replace(/(\d{3})(\d)/,"$1-$2")
                }
                return val;
            }
            function formataMoeda(e) {

                let val = e.target.value;
                if (e.code === 'Tab' || e.code === 'ShiftLeft' || e.code.includes('Arrow')) return val;
                if (!e.key.match(/^-?\d+$/) && e.key !== '.' && e.key !== ',') {

                    e.preventDefault();
                    return val.substring(0, val.length - 1);
                } else {
                    try {
                        var f2 = val.toLocaleString('pt-br', { minimumFractionDigits: 2 });

                        return f2;
                    } catch (erro) {
                        console.error(erro);
                    }
                }
            }
            function formataCPF(e) {
                let cpf = e.target.value;
                if (cpf.length >= 14 && e.key.length === 1 && e.key !== 'a') {
                    cpf = cpf.substring(0, 14)
                    e.preventDefault();
                } else {
                    cpf = cpf.replace(/\D/g, "")
                    cpf = cpf.replace(/(\d{3})(\d)/, "$1-$2")
                    cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2")
                    cpf = cpf.replace(/(\d{3})(\d{1,2})$/, "$1-$2")
                }
                return cpf;
            }
            const formataPlaca = (e) => {
                let val = e.target.value;
                if (val.length < 3) {
                    if (e.key.match(/^-?\d+$/)) {
                        val = val.replace(e.key, '');
                        e.preventDefault();
                        // return;
                    } else {
                        val = val.toUpperCase();
                    }

                } else if (val.length === 3 && e.key !== '-') {
                    val = val.toUpperCase() + "-";
                } else {
                    val = val.toUpperCase();
                }
                if (val.length >= 8 && e.key.length === 1 && e.key !== 'a') {
                    val = val.substring(0, 8)
                    e.preventDefault();
                }

                return val;
            }
            const handleKey = (e, mascara) => {

                if (e.code === 'Backspace') return;
                if (mascara) {
                    if (mascara === 'placa') {
                        e.target.value = formataPlaca(e);
                    } else if (mascara === 'cpf') {
                        e.target.value = formataCPF(e);
                    } else if (mascara === 'CEP') {
                        e.target.value = formataCEP(e);
                    } else if (mascara === 'moeda') {
                        e.target.value = formataMoeda(e);
                    }
                }
            }

            return (
                <div>
                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                        <div style={{ flex: 1 }}>
                            <TextField fullWidth
                                label={(isRequired ? '*' : '') + nomeLabel}
                                id={fieldId}
                                placeholder={nomePlaceHolder}
                                error={showError}
                                helperText={showError ? errorMessage : ''}
                                status={showError ? 'danger' : ''}
                                // onBlur={handleBlur}
                                onKeyUp={(e) => handleKey(e, mascara)}
                            />
                        </div>

                        {isIncrementavel && (
                            <Button
                                onClick={handleAddField}
                                style={{ marginTop: '25px' }}
                            >
                                <i className='fas fa-plus' style={{ fontSize: "20px", color: "#0c326f" }}></i>
                            </Button>
                        )}
                    </div>

                    {isIncrementavel && incrementavelFields.map((field) => (
                        <div
                            key={field.id}
                            data-group={fieldId}
                            style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}
                        >
                            <div style={{ flex: 1 }}>
                                <Input
                                    label={`${nomeLabel} ${field.id}`}
                                    placeholder={nomePlaceHolder}
                                    value={field.value}
                                    onChange={(e) => handleIncrementavelChange(field.id, e.target.value)}
                                />
                            </div>
                            <Button
                                onClick={() => handleRemoveField(field.id)}
                                style={{ marginTop: '22px' }}
                            >
                                <i className='fas fa-times' style={{ fontSize: "20px", color: "#0c326f" }}></i>
                            </Button>
                        </div>
                    ))}
                </div>
            );
        }

        if (field.type === "textArea") {
            return (
                <Stack >
                    <Typography>{nomeLabel}</Typography>
                    <TextareaAutosize
                        label={nomeLabel}
                        id={getPropertiesField(field, "id")}
                        placeholder={getPropertiesField(field, "placeholder")}
                        style={{ height: "170px", width: '100%', resize: "none" }}
                    // onBlur={(e) => handleBlur(fieldId, e.target.value)}
                    />
                </Stack>
            );
        }
        if (field.type === 'selectField') {
            const itens = getPropertiesField(field, "itens");
            const isRequired = getPropertiesField(field, "required");
            const myId = getPropertiesField(field,'id');
            let hasErro = false;
            if( isRequired ){
                const has = (fieldErrors && fieldErrors.find(f => f.id === myId));
                if( has) hasErro = true;
            }
            return (
                <FormControl fullWidth required={isRequired} error={hasErro}>
                    <InputLabel id={myId+"-label"}>{getPropertiesField(field,'label')}</InputLabel>
                    <Select
                        labelId={myId+"-label"}
                        id={myId}
                        // value={age}
                        label={getPropertiesField(field,'label')}
                        // onChange={handleChange}
                    >
                        {itens && itens.map((o) => (
                            <MenuItem key={o.id} value={o.label}>{o.label}</MenuItem>
                        ))}
                        
                    </Select>
                    <FormHelperText>{getPropertiesField(field, 'helper')}</FormHelperText>
                </FormControl>
            )
        }
        if (field.type === 'checkBox') {            
            const opt = getPropertiesField(field, "options");
            return (
                <FormControl>                    
                    <FormControlLabel control={
                        <Checkbox 
                            value={selectedOptions ? selectedOptions[fieldId] : ''} 
                            onChange={(e) => {
                                setSelectedOptions(prev => ({
                                    ...prev,
                                    [fieldId]: e.target.checked,
                                }));
                        }}
                        />
                    } label={getPropertiesField(field, 'label')} />
                </FormControl>
            )
        }
        if (field.type === 'radioGroup') {
            const opt = getPropertiesField(field, "options");
            
            return (
                <FormControl>
                    <FormLabel>{getPropertiesField(field, 'label')}</FormLabel>
                    <RadioGroup
                        name={"radio-buttons-group-" + fieldId}
                        //id={fieldId}
                        value={selectedOptions ? selectedOptions[fieldId] : ''}
                        onClick={(e) => {
                            setSelectedOptions(prev => ({
                                ...prev,
                                [fieldId]: e.target.value,
                            }));
                            // setInputValues(prev => ({
                            //     ...prev,
                            //     [fieldId]: "",
                            // }));
                        }}
                    >
                        {opt && opt.map((o) => (
                            <FormControlLabel key={o.id} value={o.label} control={<Radio />} label={o.label} />
                        ))}
                    </RadioGroup>
                </FormControl>
            )
        }

        if (field.type === 'radio') {
            const options = getPropertiesField(field, "options") || [];
            return (
                <div>
                    <div>
                        <h3 style={{ margin: 0, fontSize: "20px", fontWeight: "bold" }}>
                            {getPropertiesField(field, "titulo")}
                        </h3>
                        <p style={{ margin: 0, fontSize: "12px", color: "#666" }}>
                            {getPropertiesField(field, "subtitulo")}
                        </p>
                    </div>
                    {options?.map((option, index) => {
                        return (
                            <FormControl key={index}>
                                <FormLabel id={`${fieldId}_${index}`}>{option.label}</FormLabel>
                                <RadioGroup
                                    aria-labelledby={`${fieldId}_${index}`}
                                    defaultValue="female"
                                    name={fieldId}
                                >
                                    <FormControlLabel value="female" control={<Radio />} label="Female" />
                                    <FormControlLabel value="male" control={<Radio />} label="Male" />
                                    <FormControlLabel value="other" control={<Radio />} label="Other" />
                                </RadioGroup>
                            </FormControl>
                        )
                        return(
                            <RadioGroup
                                key={index}
                                label={option.label}
                                id={`${fieldId}_${index}`}
                                name={fieldId}
                                value={selectedOptions ? selectedOptions[fieldId] : ''}
                                checked={selectedOptions ? selectedOptions[fieldId] === option.value: false}
                                onClick={() => {
                                    setSelectedOptions(prev => ({
                                        ...prev,
                                        [fieldId]: option.id,
                                    }));
                                    setInputValues(prev => ({
                                        ...prev,
                                        [fieldId]: "",
                                    }));
                                }}
                            />
                        )
                    })}
                    {/* {selectedOptions[fieldId] === 2 && (
                        <Input
                            label="Digite aqui2"
                            id={`${fieldId}_input`}
                            placeholder="Informe o campo..."
                            value={inputValues[fieldId] || ""}
                            onChange={(e) =>
                                setInputValues(prev => ({
                                    ...prev,
                                    [fieldId]: e.target.value,
                                }))
                            }
                        />
                    )} */}
                </div>
            );
        }

        if (field.type === 'uploadUnico') {
            return (
                <div className="col-md-12">
                    <UploadUnico
                        label={nomeLabel}
                        id={fieldId}
                        feedbackText={uploadError ? getPropertiesField(field, "errorMessage") : ""}
                        status={uploadError ? "danger" : ""}
                        arquivo={arquivo} setArquivo={setArquivo}
                        setUploadError={setUploadError}
                        isRequired={isRequired}
                        fieldErrors={fieldErrors}
                    />
                </div>
            );
        }

        if (field.type === 'textFieldMoeda') {
            const showError = fieldErrors && fieldErrors.some(error => error.id === fieldId);
            const er = fieldErrors && fieldErrors.find(error => error.id === fieldId);
            const errorMessage = er ? er.errorMessage : getPropertiesField(field, "errorMessage");
            return (
                <TextField fullWidth
                    id={fieldId}
                    label={(isRequired ? '*' : '') + nomeLabel}
                    // type="number"
                    // slotProps={{
                    //     inputLabel: {
                    //         shrink: true,
                    //     },
                    // }}
                    error={showError}
                    helperText={showError ? errorMessage : ''}
                    status={showError ? 'danger' : ''}
                    onKeyUp={(e) => {
                        const num = parseFloat(e.target.value.replace(/\./g, '').replace(',', ''));
                        e.target.value = (isNaN(num) ? 0 : num / 100).toLocaleString('pt-BR', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        })
                    }}
                />
            );
        }
        if (field.type === 'upload') {
            return (
                <div className="col-md-12">
                    <Upload
                        label={nomeLabel}
                        id={fieldId}
                        feedbackText={uploadError ? getPropertiesField(field, "errorMessage") : ""}
                        status={uploadError ? "danger" : ""}
                        files={files} setFiles={setFiles}
                        setUploadError={setUploadError}
                        isRequired={isRequired}
                    />
                </div>
            );
        }
        if (field.type === 'camposUserLogado') {
            return (
                <Stack direction="row" spacing={2}>
                    <TextField
                        label="Nome do solicitante"
                        defaultValue={prof.profile && prof.profile.nome}
                        // variant="filled"
                        slotProps={{
                            input: {
                                readOnly: true,
                            },
                        }}
                    />
                    <TextField
                        label="Email"
                        defaultValue={prof.profile && prof.profile.email}
                        variant="filled"
                        slotProps={{
                            input: {
                                readOnly: true,
                            },
                        }}
                    />
                </Stack>
            )
        }
        if (field.type === 'dataField') {
            return (
                <div className="col-md-12">
                    <DatePicker
                        label={nomeLabel}
                        // id={fieldId}
                        slotProps={{ textField: { fullWidth: true } }}
                        // feedbackText={uploadError ? getPropertiesField(field, "errorMessage") : ""}
                        // status={uploadError ? "danger" : ""}
                        // files={files} setFiles={setFiles}
                        // setUploadError={setUploadError}
                        value={(selectedOptions && selectedOptions[fieldId]) ? selectedOptions[fieldId] : null}
                        isRequired={isRequired}
                        format="DD/MM/YYYY"
                        onChange={(e) => {
                            setSelectedOptions(prev => ({
                                ...prev,
                                [fieldId]: e,
                            }));
                        }}
                    />
                </div>
            );
        }

        return (
            <div >
                <Input
                    label="??????"
                    placeholder="Digite aqui1..."

                />
            </div>
        );
    }

    function getPropertiesField(field, name) {
        if (!field.properties) {
            return "ERROR";
        }
        const item = field.properties.find(p => p.name === name)

        return item ? item.value : 'NONE';
    }
    function handleSubmit(){
        console.log('<<<handleSubmit>>>')
    }
    function makeFormDinamico() {
        if (!task) {
            return <div>
                <Backdrop
                    sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
                    open={true}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
            </div>;
        }
        if (task.html) {
            return (
                <HtmlContent htmlString={task.html} action={handleSubmit} />
            );
        }

        if (task.cdn) {
            return (
                <iframe id="iframe" src={task.cdn + "/" + params.id} style={{ border: "none", marginTop: 10 }} height="520" width="800" title="TesteIFrame"></iframe>
            );
        }
        if (!task.form || task.form.length === 0) {
            return <h2>Não implementado</h2>;
        }
        return (
            <Box sx={{mt:1, border: '1px solid grey', p:2 }}>
                <form>
                    <Stack spacing={1}>
                        {task.form.map((field, index) => (
                            <React.Fragment key={index}>
                                {GetDynamicField(field)}
                            </React.Fragment>
                        ))}
                    </Stack>
                </form>
            </Box>
        );
    }
    function acessoOK(){
        if( processo && processo.rule){
            if( !prof.isOk) return false;
            return prof.temAcesso( processo.rule);    
        }
        return true;
    }
    if( !acessoOK() ){
        return (
            <div style={{
                textAlign: 'center',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                // width: '100vw',
                height: '75vh'
            }}
            >
                <Stack>
                <Typography variant="h5" color="error">Não permitido</Typography>
                {!prof.isOk && <div>
                    <Typography variant="body">Area restrita é necessario logar para ter acesso</Typography>
                    </div>}
                {prof.isOk && !prof.temAcesso( processo.rule) && <div>
                <Typography variant="body">{`Solicite acesso a funcionalidade "${processo.rule}" ao responsável`}</Typography><br/>
                
                </div>}
                </Stack>
            </div>
        )
    }
    return (
        <Container maxWidth="sm">
            <LocalizationProvider dateAdapter={AdapterDayjs}>

                {/* {processo && <Typography variant="body2" >{processo.nome}</Typography>} */}
                {makeFormDinamico()}
                <ConfirmDialog
                    title="Confirmação de Envio"
                    setOpen={setModalOpen}
                    open={modalOpen}
                    onClose={() => setModalOpen(false)}
                    execute={handleSalvar}
                    ok="Confirma"
                    size="small"
                >
                    <div style={{ width: "438px", padding: "16px 24px" }}>
                        <p style={{ fontSize: "16px", textAlign: "left", marginLeft: -8 }}>
                            Você está prestes a enviar sua solicitação <br />
                            Essa ação <strong>não poderá ser desfeita</strong>. Deseja continuar?
                        </p>
                        {/* <div >
                        <Button
                            onClick={() => setModalOpen(false)}
                            style={{ marginRight: "5px" }}
                        >
                            Cancelar 2
                        </Button>
                        <Button onClick={handleSalvar}>
                            Confirmar
                        </Button>
                    </div> */}
                    </div>
                </ConfirmDialog>

                {(task && !task.cdn) &&
                    <div className="d-flex justify-content-end" style={{ marginBottom: 50, marginTop: 50 }}>
                        <Button
                            style={{ marginRight: '20px' }}
                            onClick={handlerVoltar}>
                            Voltar
                        </Button>
                        <Button
                            onClick={handlerEnviar}>
                            Enviar
                        </Button>
                    </div>
                }
            </LocalizationProvider>
        </Container>
    )
}